import X24 from '../logout.svg?react';

export const Logout = {
  X24,
};
